import { rangesOverlap } from "@project-rouge/rg-three";
function isSizeCompatible(spaceA, spaceB, ignore = {
	y: false,
	z: false
}) {
	let rangeY = true;
	let rangeZ = true;
	if (!ignore.y && spaceA.attributes.sizeY && spaceB.attributes.sizeY) {
		rangeY = false;
		if (rangesOverlap(spaceA.attributes.sizeY, spaceB.attributes.sizeY)) rangeY = true;
	}
	if (!ignore.z && spaceA.attributes.sizeZ && spaceB.attributes.sizeZ) {
		rangeZ = false;
		if (rangesOverlap(spaceA.attributes.sizeZ, spaceB.attributes.sizeZ)) rangeZ = true;
	}
	return rangeY && rangeZ;
}
export { isSizeCompatible };

//# sourceMappingURL=index87.js.map